import {DialogContent, DialogContentText} from '@material-ui/core';
import {toEither} from 'Core/models/Async';
import {sequenceT} from 'fp-ts/lib/Apply';
import {either, fold} from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {renderAsync} from 'Shared/components/RenderAsync';
import {
  changeSecurityQuestionForm,
  getSecurityQuestions,
  getUserProfile,
  saveSecurityQuestions,
} from 'Users/ducks/userAccount';
import {UserClaims} from 'Users/models/Claims';
import PasswordResetSection from './PasswordResetSection';
import {LoadingTile} from './UserProfile';
import './UserProfile.sass';
import UserSecurityQuestionsSection from './UserSecurityQuestionsSection';
import {hideModal} from 'Core/ducks/modal';
import Modal from 'Shared/components/Modal';

type ReviewSecurityQuestionsAndResetPasswordModalProps = {
  userClaims: UserClaims;
};

const ReviewSecurityQuestionsAndResetPasswordModal = ({
  userClaims,
}: ReviewSecurityQuestionsAndResetPasswordModalProps) => {
  const dispatch = useDispatch();
  const {questions, securityQuestionForm} = useSelector((state: ReducerState) => state.user.userAccount);

  useEffect(() => {
    dispatch(getUserProfile(userClaims.id));
    // dispatch(getSecurityQuestions());
  }, [getUserProfile, getSecurityQuestions, userClaims.id]);

  const securityQuestionData = sequenceT(either)(toEither(questions), toEither(securityQuestionForm));

  return (
    <Modal title="Review Security Questions and Update Password" open>
      <DialogContent>
        <div className="user-profile user-profile__modal">
          <div>
            <DialogContentText>Please review all your Security Questions and update your Password.</DialogContentText>
            {pipe(
              securityQuestionData,
              fold(
                error => renderAsync(error, LoadingTile),
                ([questions, securityQuestionForm]) => {
                  return (
                    <UserSecurityQuestionsSection
                      onChange={securityQuestionForm => dispatch(changeSecurityQuestionForm(securityQuestionForm))}
                      userId={userClaims.id}
                      saveSecurityQuestions={(encryptedIdentifier, userId, securityQuestionForm) =>
                        dispatch(saveSecurityQuestions(encryptedIdentifier, userId, securityQuestionForm))
                      }
                      securityQuestionForm={securityQuestionForm}
                      securityQuestions={questions}
                    />
                  );
                }
              )
            )}
            <PasswordResetSection onReset={() => dispatch(hideModal())} />
          </div>
        </div>
      </DialogContent>
    </Modal>
  );
};

export default ReviewSecurityQuestionsAndResetPasswordModal;
